import { Modal } from "flowbite-react";
import { useToastContext } from "@/common/components/ui/toast/toast.context";
import { IContractB2B } from "@/types/contractB2B.type";
import {
  createContractB2B,
  updateContractB2B,
} from "@/common/services/contracts-b2b.api";
import FormCreateContractB2B from "../form/FormCreateContractB2B";

type Props = {
  onClose: () => void;
  onSave: (contract: IContractB2B) => void;
  isOpen: boolean;
  title: string;
  contractData?: IContractB2B;
};
export default function ModalContractB2B(props: Props) {
  const { notifySuccess, notifyError } = useToastContext();
  const isEditing = !!props.contractData;

  const handleCloseModal = () => {
    props.onClose();
  };

  async function handleSubmit(dataToSave: {
    valor: string;
    vencimento: Date;
    vehicles: { licensePlate: string }[];
    idCompanyB2B: string;
  }) {
    try {
      const contractId = props.contractData?._id;

      let result;

      const dataToApi = {
        ...dataToSave,
        active: true,
      };

      if (isEditing && contractId) {
        result = await updateContractB2B(contractId, dataToApi);
      } else {
        result = await createContractB2B(dataToApi);
      }

      const { ok, data } = result;
      if (ok && data) {
        props.onSave(data as IContractB2B);
        const actionText = isEditing ? "atualizado" : "cadastrado";
        notifySuccess(
          `Contrato #${(data as IContractB2B)._id.substring(
            0,
            8
          )}... ${actionText} com sucesso!`
        );
        handleCloseModal();
      } else if (!result.ok) {
        notifyError(
          (result as { message?: string })?.message ||
          `Erro ao ${isEditing ? "atualizar" : "cadastrar"} contrato.`
        );
      }
    } catch (err) {
      console.error(err);
      notifyError(
        (err as Error).message ||
        `Erro desconhecido ao ${isEditing ? "atualizar" : "cadastrar"
        } contrato.`
      );
    }
  }

  return (
    <Modal
      className="relative text-black"
      show={props.isOpen}
      onClose={handleCloseModal}
    >
      <Modal.Header className="text-black">
        <h2 className="text-black">Novo Contrato B2B</h2>
      </Modal.Header>
      <Modal.Body>
        <FormCreateContractB2B
          onSubmit={handleSubmit}
          initialData={props.contractData}
        />
      </Modal.Body>
    </Modal>
  );
}
